import React, { useMemo, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';

import { InfoButton } from 'components';
import { Box, Typography } from '@mui/material';
import { useSmallScreen } from 'utils/hooks/ui';

const TunnelStep = props => {
    const { title, children, subtitle, tunnelStepWidth = 1090, maxWidth = 660, ...rest } = props;
    const location = useLocation();
    const isSmallScreen = useSmallScreen('xs');
    const isFirstStep = location.pathname === '/sign-up' || location.pathname === '/sign-up/';
    const thisRef = useRef();

    const subtitleComponent = useMemo(() => {
        if (typeof subtitle === 'string') {
            return subtitle.trim() ? <Typography variant="subtitle1">{subtitle}</Typography> : null;
        }
        return subtitle;
    }, [subtitle]);

    return (
        <Box id="tunnel-step" width="100%" paddingX="20px" paddingY="30px" ref={thisRef} {...rest}>
            <Box
                maxWidth={810}
                display="flex"
                textAlign="center"
                mx="auto"
                mt={isFirstStep ? '57px' : 0}
                mb={!!subtitle && !isSmallScreen ? '60px' : 0}
                flexDirection="column"
                justifyContent="space-between"
            >
                <Typography
                    sx={theme => ({
                        marginBottom: '30px',
                        [theme.breakpoints.down('sm')]: { fontSize: 30 },
                    })}
                    variant="h2"
                >
                    {title}
                </Typography>
                {!!subtitle && !isSmallScreen && subtitleComponent}
            </Box>

            {isSmallScreen && !!subtitleComponent && (
                <Box mb={5}>
                    <InfoButton
                        disableMarginBottom
                        title={title}
                        content={subtitleComponent}
                        style={{ float: 'right' }}
                    />
                </Box>
            )}
            <Box maxWidth={maxWidth || tunnelStepWidth} margin="0 auto">
                {children}
            </Box>
        </Box>
    );
};

TunnelStep.propTypes = {
    title: PropTypes.node.isRequired,
    subtitle: PropTypes.node,
    children: PropTypes.node,
    tunnelStepWidth: PropTypes.number,
    maxWidth: PropTypes.number,
};

export default TunnelStep;
